// ThemeContext.js
import React, { createContext, useContext, useState } from "react";

// Create a Theme Context
const ThemeContext = createContext();

// Custom hook to use the Theme Context
export const useTheme = () => useContext(ThemeContext);

// Provider component
export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState("light"); // Default theme is light

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            <div
                className={
                    theme === "dark"
                        ? "bg-gray-900 text-white"
                        : "bg-white text-black"
                }
            >
                {children}
            </div>
        </ThemeContext.Provider>
    );
};
